<template>
  <section class="content">
      <!-- <div class="box box-info"> -->
        <form >
            <website ref="website"/>
            <div class="name">
            <div class="page section-header text-center">
              <h1 >PRIVACY POLICY</h1>
            </div>
            <div class="page-width">
              <div class="rte"></div>
              <div class="page-width">
                <div class="custom-content"> 
                <div class="custom__item custom__item--1537787486018 one-whole align--center">
                  <div class="medium-up--text-center">

<p data-custom-class="title">
<b>
    <strong> PRIVACY NOTICE </strong>
</b>
</p> 
 <p data-custom-class="title">
<b>
    <strong> Last updated August 26, 2020 </strong>
</b>
</p> 
    
    <div class="rte-setting">
<p>
Thank you for choosing to be part of our community at Lilpicks, doing business as “we”, “us”, or “our”. We are committed to protecting your personal information and your right to privacy. If
you have any questions or concerns about this privacy notice, or our practices with regards to your personal information, please contact us at info@majesticbookclub.com.
</p>
When you visit our website https://lilpicks.com/ (the "Website"), and more generally, use any of our services (the "Services", which include the Website), we appreciate that you are trusting
us with your personal information. We take your privacy very seriously. In this privacy notice, we seek to explain to you in the clearest way possible what information we collect, how we use it
and what rights you have in relation to it. We hope you take some time to read through it carefully, as it is important. If there are any terms in this privacy notice that you do not agree with,
please discontinue use of our Services immediately.
<p>
This privacy notice applies to all information collected through our Services (which, as described above, includes our Website), as well as any related services, sales, marketing or events.
In 2020, We started catering worldwide and Successful Delivered Orders to Singapore, Malaysia and Dubai.
  <p data-custom-class="title">
<b>
    <strong> Please read this privacy notice carefully as it will help you understand what we do with the information that we collect. </strong>
</b>
</p> 
    </div>

  <p data-custom-class="title">
<b>
    <strong> TABLE OF CONTENTS </strong>
</b>
</p> 
1.WHAT INFORMATION DO WE COLLECT?
2.HOW DO WE USE YOUR INFORMATION?
3.WILL YOUR INFORMATION BE SHARED WITH ANYONE?
4. HOW DO WE HANDLE YOUR SOCIAL LOGINS?
5.HOW LONG DO WE KEEP YOUR INFORMATION?
6.HOW DO WE KEEP YOUR INFORMATION SAFE?
7.WHAT ARE YOUR PRIVACY RIGHTS?
8.CONTROLS FOR DO-NOT-TRACK FEATURES
9.DO CALIFORNIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?
10.DO WE MAKE UPDATES TO THIS NOTICE?
11.HOW CAN YOU CONTACT US ABOUT THIS NOTICE?
<br/>
<br/>

                  </div>
                </div>

                </div>
              </div>

            </div>
      </div>
      <footerWebsite ref="footerWebsite"/>
</form>
    <!-- </div> -->
  </section>
</template>
<script>
import website from '../ecommerce/website.vue'
import footerWebsite from '../ecommerce/footerWebsite.vue'
export default {
  name: 'privacyPolicy',
  props: ['privacyPolicy'],
  data() {
    return {
      name: '',
      layout: 'grid',
      sortOrder: null,
      sortField: null,
      sortOptions: [
       {label: 'Price High to Low', value: '!price'},
       {label: 'Price Low to High', value: 'price'}
      ],
      englishDateEnabled: true,
      transactionDate: null,
      account: '',
      txnAmountDr: 0,
      txnAmountCr: 0,
      narration3: '',
      narration: '',
      drCr: '',
      drtotal: 0,
      crTotal: 0,
      difference: 0,
      chequeDate: null,
      chequeNumber: '',
      transactionDetailDTOList: [],
      transactionDeleteList: [],
      bank: false,
      editing: false,
      voucherNo: null,
      editDTO: false,
      index: null,
      tranId: null,
      tranModuleType: null,
      loading: false,
      cheque: false,
      filteredAccounts: null,
      products: null
    }
  },
  computed: {
  },
  mounted() {
  },
  methods: {
  },
  components: {
    website,
    footerWebsite
  }
}
</script>
<style scoped  src="@../../../static/css/website.css" >
.p {
    margin: 0 0 20px;
}
</style>



// WEBPACK FOOTER //
// privacyPolicy.vue?dc2e3d4c